module.exports = __webpack_public_path__ + "img/155.34e5c23e.jpg";